import React from 'react';
import Grid from '@material-ui/core/Grid';
import { AppDashboardCard } from 'pages/HomePage';
import PermissionsComponent from 'components/Wrappers/PermissionsComponent';
import pages from 'components/layout/left-panel/pages';
import { useLocation } from 'react-router';
import { isSubMenu } from 'components/layout/left-panel/PagesMenu';

function SubMenuPage() {
  const location = useLocation();

  return (
    <div>
      <Grid container spacing={ 1 }>
        {pages
          .map((page) => {
            const { title, path, permissions, icon: Icon, menu } = page;
            return (
              <PermissionsComponent
                key={ path }
                permissions={ permissions }
              >
                { ((location.pathname === `/submenu/${ menu }` && (isSubMenu(menu)))
                ) && (
                  <Grid item sm={ 6 } md={ 4 } lg={ 4 } key={ page.key }>
                    <AppDashboardCard
                      title={ title }
                      path={ path }
                      icon={ Icon }
                    />
                  </Grid>
                )}
              </PermissionsComponent>
            );
          })}
      </Grid>
    </div>
  );
}

export default SubMenuPage;
